import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { createPaymentIntent } from './redux/actions';
import { appConfig } from "../app-config";

const PaymentMethod = ({ handleNext, updateSharedData }) => {
    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState("");
    const getDataFive =() => {
      const queryParams = new URLSearchParams(window.location.search);
      let dataFive = queryParams.get('dataFive');
    
      if (!dataFive && window.location.hash) {
        const hashParams = new URLSearchParams(window.location.hash.slice(1));
        dataFive = hashParams.get('dataFive');
      }
    
      return dataFive;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('dataOne');
    const name = urlParams.get('dataThree');
    const sub_name = urlParams.get('dataFour');
    const image = getDataFive();
    const supplier_id = urlParams.get('dataTwo');
    const userId = urlParams.get('dataSix');
    const paymentMethodId = urlParams.get('dataSeven') ?  urlParams.get('dataSeven')?.split(',') : [];
    const venorId = urlParams.get('dataEight');
    const currentLanguage = urlParams.get('dataNine') || "en";
    const csrfToken = urlParams.get('dataTen');
    const sessionId = urlParams.get('dataEleven');
    const stepId = Number(urlParams.get('dataTwelve'));
    const dataObj = {
      "projectId": id, 
      "supplier_id": Number(supplier_id), 
      "projectName": name, 
      userId: userId,
      projectImage: image, 
      venorId: venorId,
      paymentIntent:  JSON.parse(sessionStorage.getItem("sharedData"))?.paymentIntent,
      "paymentMethodId": paymentMethodId,
      "language":currentLanguage, 
      "csrfToken": csrfToken, 
      "sessionId": sessionId,
      donationAmount: JSON.parse(sessionStorage.getItem("sharedData"))?.donationAmount
    };
    const [sharedData, setSharedData] =  useState(dataObj);

    useEffect(() => {
        setStripePromise(loadStripe(appConfig.STRIPE_PUBLIC_KEY));
    }, []);
    const appearance = {
      theme: 'stripe',
      variables: {
        colorText: '#111',
        colorDanger: '#df1b41',
        borderRadius: '4px',
        fontSizeBase: '14px'	
      },
    };



    useEffect(()=>{
      const originalString = sharedData?.donationAmount?.currency;
      const lowercaseStringCurrency = originalString?.toLowerCase();
        const apiReq = {
          "mode": 'payment',
          "amount": sharedData?.donationAmount?.totalAmount,
          "givesomeTip": sharedData?.donationAmount?.givesomeTip,
          "currency": lowercaseStringCurrency,
          "description": sharedData?.donationAmount?.description+' (to '+sharedData.projectName+')',
          "paymentMethodId": sharedData?.paymentMethodId,
          "userId": sharedData?.userId  !== "None"  ? sharedData?.userId : null,
          "isRecurringEnabled": sharedData?.donationAmount?.isRecurringEnabled,
          "projectEndDate": sharedData?.donationAmount?.projectEndDate,
          "recurringInterval": sharedData?.donationAmount?.recurringInterval,
          "projectId": sharedData?.projectId,
        }

        // sessionStorage.removeItem("sharedData");

        createPaymentIntent(apiReq).then((response) => {
              // if(response.code && response.code  !== "") {
              //   return
              // }
              if (response && response.data && response.data.status === 200) {
                const paymentIntent  = {
                  "clientSecret": response.data.data.clientSecret,
                  "paymentIntentId": response.data.data.paymentIntentId,
                  "paymentCardDetails": response?.data?.data
              }
              const updatedData = { ...sharedData, paymentIntent };
              updateSharedData(updatedData);

              setClientSecret(response.data.data.clientSecret);
              sessionStorage.setItem("sharedData", JSON.stringify(updatedData));
              setSharedData(updatedData);

              }
              if (response && response.data && response.data.status !== 200) {
              }
            })
            .catch((error) => {
              console.error('Error fetching data:', error);
            });
    },[sharedData?.donationAmount])
    
    return (
      <>
        {clientSecret && stripePromise && (
          <Elements stripe={stripePromise} options={{ clientSecret, appearance,  locale:  sharedData?.language }}>
            <CheckoutForm handleNext={handleNext} sharedData={sharedData} updateSharedData={updateSharedData} csKey={clientSecret}/>
          </Elements>
        )}
      </>
    );
};



export default PaymentMethod